import React, { useEffect, useState } from 'react';

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch('https://api.virajpargaonkar.me/api/projects')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch projects');
        return res.json();
      })
      .then((data) => {
        setProjects(data);
      })
      .catch((err) => {
        console.error(err);
        setProjects([]);
      });
  }, []);

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1>Projects</h1>
          <p>
            Selected work that showcases my skills in building robust web
            applications.
          </p>
        </div>
      </section>
      <main className="page-content">
        <div className="container">
          <div className="projects-grid">
            {projects.map((proj) => (
              <div className="project-card" key={proj.id} data-aos="fade-up">
                <div className="project-icon">
                  {/* Use a generic icon for all projects; icons could be mapped based on name */}
                  <i className="fas fa-project-diagram"></i>
                </div>
                <h3>{proj.name}</h3>
                <p>{proj.description}</p>
                {proj.link && (
                  <a href={proj.link} target="_blank" rel="noopener noreferrer">
                    Learn more
                  </a>
                )}
              </div>
            ))}
          </div>
           <div className="project-extra-link">
            <a 
            href="https://github.com/virajnp" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="github-link"
            >
             <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
              alt="GitHub"
              style={{ width: "24px", height: "24px" }}
             />
             <i className="fab fa-github"></i> View More on GitHub
            </a>
           </div>
        </div>
      </main>
    </>
  );
}

export default Projects;